import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Star, Loader2 } from "lucide-react";
import api from "../services/api";
import { toast } from "sonner";

export default function RatingModal({ trackingId, open, onClose, onRated }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) return toast.error("Please select a rating");
    setSubmitting(true);
    try {
      await api.post(`/orders/${trackingId}/rate`, { rating, comment: comment || null });
      toast.success("Thanks for your rating!");
      onRated?.();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to submit rating");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm rounded-2xl" aria-describedby="rate-desc">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl font-semibold text-slate-900 text-center">Rate Your Delivery</DialogTitle>
          <p id="rate-desc" className="text-sm text-slate-500 text-center">How was your experience with {trackingId}?</p>
        </DialogHeader>
        <div className="space-y-5 mt-2">
          <div className="flex justify-center gap-2" data-testid="rating-stars">
            {[1, 2, 3, 4, 5].map((s) => (
              <button
                key={s}
                onClick={() => setRating(s)}
                onMouseEnter={() => setHover(s)}
                onMouseLeave={() => setHover(0)}
                className="transition-transform hover:scale-110"
                data-testid={`star-${s}`}
              >
                <Star
                  className={`h-9 w-9 transition-colors ${
                    s <= (hover || rating) ? "text-amber-400 fill-amber-400" : "text-slate-200"
                  }`}
                />
              </button>
            ))}
          </div>
          <textarea
            placeholder="Any feedback? (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="w-full rounded-xl border border-slate-200 p-3 text-sm resize-none h-20 focus:border-[#FF6B00] focus:ring-1 focus:ring-[#FF6B00]/20 outline-none"
            data-testid="rating-comment"
          />
          <Button onClick={handleSubmit} disabled={submitting || rating === 0} className="w-full bg-[#FF6B00] text-white hover:bg-[#E65A00] rounded-xl h-12 font-semibold btn-press" data-testid="submit-rating-btn">
            {submitting ? <Loader2 className="h-5 w-5 animate-spin mr-2" /> : null}
            {submitting ? "Submitting..." : "Submit Rating"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
